// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","container":"_9yrn_dNQcz-uL2apHsFuo","title":"Y67fGeJ7688QdF1xL8fvi","text":"_2HYmz4bTzVMJUWeKcDj8wq"};